import { find } from 'lodash';
import React from 'react';

import CreateListForm from './CreateListForm';
import SavedListItem from './SavedListItem';

import styles from './listDropDown.scss';

const _ = { find };

class ListDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleChange(event) {
        this.setState({
            query: event.target.value,
        });
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && (this.props.showLists || this.props.showCreateList)) {
            this.props.closeListsDropDown();
        }
    }

    render() {
        const selectedItem = _.find(this.props.savedLists, { id: this.props.selectedListId });
        const { listType, listFor = '' } = this.props;
        const SavedLists = () => {
            return (
                <div className={`${styles.savedLists}`}>
                    <h6 className={`${styles.title}`}>
                        Open Lists
                    </h6>
                    <div className={`${styles.searchContainer}`}>
                        <input
                            type="text"
                            className={`form-control ${styles.searchInput}`}
                            placeholder="Type to find a list"
                            onChange={this.handleChange}
                            autoFocus="autoFocus"
                            value={this.state.query}
                            onFocus={(e) => {
                                const val = e.target.value;
                                e.target.value = '';
                                e.target.value = val;
                            }}
                            data-testid="list-dropdown.search-input"
                        />
                    </div>
                    <div className={`${styles.listContainer}`}>
                        {this.props.savedLists.map((list) => {
                            if (this.state.query.length === 0 || (list.name && list.name.toLowerCase().indexOf(this.state.query.toLowerCase()) !== -1)) {
                                return (
                                    <SavedListItem
                                        key={`saved-lists-${list.id}`}
                                        data={list}
                                        listType={this.props.listType}
                                        onListSelected={this.props.onListSelected}
                                        onListDeleted={this.props.onListDeleted}
                                    />
                                );
                            }
                            return null;
                        })}

                    </div>
                </div>
            );
        };

        return (
            <div className={`${styles.dropDownRoot}`}>
                <div className={`d-flex flex-row flex-nowrap align-items-end ${styles.dropDownAnchor}`}>
                    {this.props.savedLists && this.props.savedLists.length > 0 && (
                        <div
                            className={`${styles.selectedList}`}
                            onClick={this.props.openSavedListsDropDown}
                            data-testid="list-dropdown.selected-list-toggle"
                        >
                            <span className={`${styles.selectedListName}`}>
                                {selectedItem ? selectedItem.name : 'Select A List'}
                            </span>
                            <span className={`fas fa-chevron-down ${styles.selectedListDropDownIcon}`} />
                        </div>
                    )}
                    <button
                        type="button"
                        className={`btn btn-primary btn-sm text-uppercase ${styles.createListButton}`}
                        onClick={this.props.openCreateListForm}
                        data-testid="save-to-list.create-list-btn"
                    >
                        <span className={`fas fa-plus`} />
                    </button>
                </div>
                {(this.props.showLists || this.props.showCreateList) && (
                    <div>
                        <div className={`${styles.anchorClickDisabler}`} />
                        <div
                            className={`${styles.dropDownContainer}`}
                            style={{ width: '' }}
                            ref={this.setWrapperRef}
                        >
                            {this.props.showLists && (
                                <SavedLists />
                            )}
                            {this.props.showCreateList && (
                                <CreateListForm
                                    onSubmit={this.props.handleCreateList}
                                    onCancel={this.props.closeListsDropDown}
                                    listCreationFailed={this.props.listCreationFailed}
                                    errorMessage={this.props.errorMessage}
                                    creatingListName={this.props.creatingListName}
                                    listType={listType}
                                    listFor={listFor}
                                    power6SortField={this.props.power6SortField}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ListDropDown;
